module.exports = __webpack_public_path__ + "static/media/HopeForTheFuture.2cc095ad.ogg";